<template>
  <div class="wrapper">
    <div class="wrapper-header">
      <TabsWidget activeTab="event_stream" @selected="switchTab"></TabsWidget>
      <div class="tab-options">
        <b-button type="is-dark" v-if="stream_data && !is_waiting_streamed_video" :loading="end_stream_loading" outlined
          @click="endStream()">END
          STREAM</b-button>
        <b-button type="is-dark" v-if="stream_data && is_waiting_streamed_video" outlined
          :loading="close_stream_loading" @click="closeStream()">CLOSE
          STREAM</b-button>
        <b-button type="is-primary" v-else-if="!stream_data_loading && !stream_data" :loading="add_stream_loading"
          outlined @click="startNewStream()">START NEW STREAM</b-button>

      </div>
    </div>
    <div class="wrapper-body">
      <div v-if="!stream_data_loading && stream_data" class="left-panel" :class="{ chat_enabled: form.allow_chat }">
        <div class="video-preview-widget">
          <div v-if="!form.allowStreamFromOtherSource" class="video-preview-widget-container">
            <div v-if="is_waiting_streamed_video" class="video-preview-widget-loading-widget">
              <div class="video-preview-loader">
                <loading :height="100" color="#fff" :opacity="1" :width="100" :active.sync="is_waiting_streamed_video"
                  :is-full-page="false" :can-cancel="false" background-color="#000" class="loader"></loading>
              </div>
              <div class="video-preview-waiting">
                <h4>Connect streaming software to go live</h4>
                <h3>Viewers will be able to find your stream once you go live </h3>
              </div>
            </div>
            <div v-else class="video-player-widget">
              <ClapprPlayer v-if="playerType == 'clappr'"
                :src="`${playbackType == 'hls' ? hlsStreamingPath : dashStreamingPath}`" :type="playbackType">
              </ClapprPlayer>
              <OvenPlayer v-else-if="playerType == 'oven'" :webRTCUrl="`${webRtcStreamingPath}`" :muted="true"
                :latency="form.stream_latency">
              </OvenPlayer>
            </div>
          </div>
          <div v-if="form.allowStreamFromOtherSource" class="video-preview-widget-container">
            <div class="video-player-widget">
              <YTPlayer v-if="form.otherSourceUrl" :url="form.otherSourceUrl"></YTPlayer>
            </div>
          </div>
          <div class="stream-details">
            <div class="stream-details-item space-between">
              <div class="stream-details-content">
                <div class="field-title">Title</div>
                <div class="field-value">{{ form.title }}</div>
              </div>
              <div class="stream-details-options">
                <b-button v-if="form.allow_chat" @click="toggleLiveChatMobile()" class="liveChatBtn"
                  type="is-default">LIVE CHAT</b-button>
                <b-button @click="showUpdateDetailsModal()" type="is-primary" class="live_chat">EDIT</b-button>
              </div>
            </div>
            <div class="stream-details-item">
              <div class="stream-details-content">
                <div class="field-title">Link</div>
                <div class="field-value link">
                  <a target="_blank" class="crop-text"
                    :href="`${$store.state.SITE_BASE_URL}watch/live/${stream_data.id}/${stream_data.slug}`" v-html="`${$store.state.SITE_BASE_URL}watch/live/${stream_data.id}/${stream_data.slug}`
                      "></a>
                </div>
              </div>
            </div>
            <div class="stream-details-item">
              <div class="stream-details-content">
                <div class="field-title" style="margin-bottom: 8px;">Privacy
                  <b-tooltip type="is-dark" position="is-bottom">
                    <img width="15" src="@/assets/images/icons/info.svg">
                    <template v-slot:content>
                      <p>
                        <b>Public</b> - Anyone can watch your stream
                      </p>
                      <p>
                        <b>Preview</b> - Only you in admin can watch but not public, it will show up in search results
                      </p>
                      <p>
                        <b>Unlisted</b> - Only people with the link can watch your stream and it won't show up in
                        search results
                      </p>
                      <p>
                        <b>Private(Coming Soon)</b> - Only invited members can watch your stream
                      </p>
                    </template>
                  </b-tooltip>
                </div>
                <div class="field-value link">
                  <b-field>
                    <p class="control">
                      <b-button
                        :type="form.visibility == 'Public' ? 'is-success' : form.visibility == 'Private' ? 'is-warning' : ''"
                        :label="form.visibility" />
                    </p>
                    <p class="control">
                      <b-dropdown animation="none">
                        <template #trigger>
                          <b-button icon-left="menu-down" />
                        </template>

                        <b-dropdown-item @click="form.visibility = 'Public'">Public</b-dropdown-item>
                        <b-dropdown-item @click="form.visibility = 'Preview'">Preview</b-dropdown-item>
                        <b-dropdown-item @click="form.visibility = 'Unlisted'">Unlisted</b-dropdown-item>
                        <b-dropdown-item @click="form.visibility = 'Private'">Private</b-dropdown-item>
                      </b-dropdown>
                    </p>
                  </b-field>
                </div>
              </div>
            </div>

            <div class="stream-details-item">
              <div class="stream-details-content">
                <div class="field-title">
                  {{
                    is_waiting_streamed_video
                      ? "Viewers waiting"
                      : "Viewers watching"
                  }}
                </div>
                <div class="field-value">
                  {{ users_current_live }}
                  {{ is_waiting_streamed_video ? " waiting" : "watching" }}
                </div>
              </div>
              <div class="h-spacer"></div>
              <div class="stream-details-content">
                <div class="field-title">Eaning</div>
                <div class="field-value">
                  <b-input class="money-reveal-input" type="password" :value="$formatMoney(
                    current_earnings,
                    (decimalCount = 0),
                    (decimal = '.'),
                    (thousands = ',')
                  )" readonly password-reveal>
                  </b-input>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="stream-status-widget" v-if="!form.allowStreamFromOtherSource">
          <div class="stream-dot" :class="{ active: !is_waiting_streamed_video }"></div>
          <div class="stream-status" v-if="is_waiting_streamed_video">
            Start sending us your video from your streaming software to go live
          </div>
          <div class="stream-status" v-else>Now you are live</div>
        </div>
        <div class="stream-status-widget" v-else>
          <div class="stream-dot active"></div>
          <div class="stream-status">Ready to stream from other source</div>
        </div>
        <div class="stream-tab-header">
          <div class="tabs-widget">
            <div class="tab-item" :class="{ active: stream_tab == 'settings' }" @click="switchStreamTab('settings')">
              STREAM SETTINGS
            </div>
            <div class="h-spacer"></div>
            <div class="tab-item" :class="{ active: stream_tab == 'health' }" @click="switchStreamTab('health')">
              STREAM HEALTH
            </div>
            <div class="h-spacer"></div>
            <div class="tab-item" :class="{ active: stream_tab == 'logs' }" @click="switchStreamTab('logs')">
              STREAM LOGS
            </div>
            <div class="h-spacer"></div>
            <div class="tab-item" :class="{ active: stream_tab == 'analytics' }" @click="switchStreamTab('analytics')">
              VIEWS ANALYTICS
            </div>
            <div class="h-spacer"></div>
            <div class="tab-item" v-if="!form.allowStreamFromOtherSource" :class="{ active: stream_tab == 'sessions' }"
              @click="switchStreamTab('sessions')">
              ENDED SESSIONS
            </div>
          </div>
          <div class="tab-options"></div>
        </div>
        <EventStreamSettings v-if="stream_tab == 'settings' && channel" :form="form"
          :isPlaying="!is_waiting_streamed_video" @updated="onSettingsUpdated">
        </EventStreamSettings>
        <EventStreamHealth v-if="stream_tab == 'health'" :form="form" :event="stream_data" :streamKey="form.stream_key"
          :status="stream_status">
        </EventStreamHealth>
        <EventStreamLogs v-if="stream_tab == 'logs' && stream_data" :form="form" :event="stream_data"
          :streamKey="form.stream_key"></EventStreamLogs>
        <EventStreamAnalytics v-if="stream_tab == 'analytics' && stream_data" :event="stream_data">
        </EventStreamAnalytics>
        <EventStreamSessions v-if="stream_tab == 'sessions'" :stream_key="form.stream_key" :event="stream_data">
        </EventStreamSessions>
      </div>
      <div v-if="!stream_data_loading && !stream_data" class="left-panel">
        <widgetNotfound title="No Stream Found or Ended" subtitle="Click on Start New Stream to get started ">
        </widgetNotfound>
      </div>

      <div v-if="stream_data_loading" class="left-panel">
        <div class="loading-container">
          <loading :height="70" color="#000" :opacity="1" :width="70" :active.sync="stream_data_loading"
            :is-full-page="false" :can-cancel="false" background-color="#ffffff" class="content-loader"></loading>
        </div>
      </div>

      <div class="rigth-panel" v-if="stream_data"
        :class="{ show: form.allow_chat && !stream_data_loading, show_mobile: toggleChat }">
        <div class="right-panel-header">
          <h3>
            LIVE CHAT
            <span @click="toggleLiveChatMobile()">Hide</span>
          </h3>
        </div>
        <div class="right-panel-body" id="streaming-live-chat-body">
          <div class="chat-list">
            <div class="chat-item" v-for="(item, index) in chats" :key="index">
              <div class="chat-user-profile">
                <widgetProfile v-if="item.user_name" :title="`${item.user_name}`" subtitle=""
                  :file_name="item.user_image" :path="$store.state.ASSETS_BASE_URL + '/assets/uploaded/'" :text_size="8"
                  :size="23" :showContent="false">
                </widgetProfile>
                <widgetProfile v-else :title="`${item.first_name} ${item.last_name}`" subtitle=""
                  :file_name="item.user_image" :path="$store.state.ASSETS_BASE_URL + '/assets/uploaded/'" :text_size="8"
                  :size="23" :showContent="false">
                </widgetProfile>
              </div>
              <div class="chat-message">
                <div v-if="item.user_name" class="chat-user-name">
                  {{ item.user_name }}
                </div>
                <div v-else class="chat-user-name">
                  {{ item.first_name }} {{ item.last_name }}
                </div>
                {{ item.message }}
              </div>
            </div>
          </div>
        </div>
        <div class="right-panel-footer">
          <div class="custom-name">
            <b-input class="user-name" v-model="chat_form.user_name" placeholder="Type your name here"
              type="text"></b-input>
            <div class="chat-send">
              <b-button @click="sendChatMessage" :loading="loading_send_message" type="is-primary">SEND</b-button>
            </div>
          </div>
          <div class="chat-input-widget">
            <div class="chat-input">
              <b-input v-model="chat_form.message" placeholder="Type your message here" type="textarea"></b-input>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Update Stream details modal -->
    <UpdateStreamDetailsModal v-if="show_update_stream_details_modal" :stream="stream_data"
      @saved="onStreamDetailsSaved" @close="show_update_stream_details_modal = false"></UpdateStreamDetailsModal>
  </div>
</template>

<script>
import { v4 as uuidv4 } from "uuid";
import UpdateStreamDetailsModal from "./modals/EventUpdateStreamDetailsModal.vue";
import EventStreamSettings from "./components/EventStreamSettings.vue";
import EventStreamHealth from "./components/EventStreamHealth.vue";
import EventStreamLogs from "./components/EventStreamLogs.vue";
import EventStreamAnalytics from "./components/EventStreamAnalytics.vue";
import EventStreamSessions from "./components/EventStreamSessions.vue";
import TabsWidget from "./components/TabsWidget.vue";
import { MEDIA_SERVER_BASE_URL, STREAMING_CDN_SERVER_BASE_URL, LIVE_STREAMING_CDN_SERVER_BASE_URL } from "@/store/variables.js";
export default {
  components: {
    UpdateStreamDetailsModal,
    EventStreamSettings,
    EventStreamHealth,
    EventStreamLogs,
    EventStreamAnalytics,
    EventStreamSessions,
    TabsWidget,
  },
  sockets: {
    socketServer: {
      connect: function () { },
      onMessageReceived: function (data) {
        let vm = this;
        let chat_list = document.querySelector("#streaming-live-chat-body");
        if (data.event_id == vm.form.id) {
          vm.chats.push(data.chat);
          setTimeout(() => {
            chat_list.scrollTo({
              top: chat_list.scrollHeight,
              behavior: "smooth",
            });
          }, 100);
        }
      },
    },
  },
  data: () => ({
    show_player: true,
    toggleChat: false,
    users_current_live: 0,
    is_waiting_streamed_video: true,
    playerType: "clappr",
    playbackType: "hls",
    dashStreamingPath: "",
    hlsStreamingPath: "",
    webRtcStreamingPath: "",
    stream_data: null,
    stream_data_loading: false,
    form: {
      id: null,
      title: "Untitled live streaming",
      channel_id: null,
      category: "event",
      visibility: "Private",
      stream_key: "",
      stream_url: "",
      stream_latency: "normal",
      allow_payment: false,
      keep_video: false,
      show_views: false,
      allow_chat: false,
      allow_super_chat: false,
      allow_remote_input: false,
      remote_input_headers: "",
      player_url: "",
      allowStreamFromOtherSource: false,
      otherSourceUrl: "",
      donationId: null,
    },
    add_stream_loading: false,
    show_update_stream_details_modal: false,
    stream_tab: "settings",
    update_stream_setting_loading: false,
    current_earnings: 0,
    chats: [],
    channel: null,
    streamingStatusTimer: null,
    earningAmountTimer: null,
    whoseWatchingTimer: null,
    close_stream_loading: false,
    end_stream_loading: false,
    chat_form: {
      user_name: "",
      message: ""
    },
    loading_send_message: false,
    stream_status: "",
  }),
  watch: {
    form: {
      handler: function (form) {
        let vm = this;
        vm.onSettingsUpdated(form);
      },
      deep: true,
    },
  },
  mounted() {
    let vm = this;
    vm.getMyChannelDetails();
    vm.checkStreamingStatus();
    vm.whoseWatchingTimer = setInterval(function () {
      vm.countWhoseWatching();
    }, 1000 * 5);
    vm.earningAmountTimer = setInterval(function () {
      vm.getEarningAmount();
    }, 1000 * 30);

  },
  beforeDestroy() {
    let vm = this;
    clearInterval(vm.earningAmountTimer);
    clearInterval(vm.streamingStatusTimer);
    clearInterval(vm.whoseWatchingTimer);
  },
  methods: {
    toggleLiveChatMobile() {
      this.toggleChat = !this.toggleChat
    },
    checkStreamingStatus() {
      let vm = this;
      vm.streamingStatusTimer = setInterval(function () {
        if (vm.channel && vm.channel.event_live_input.stream_key && vm.stream_data) {
          vm.$store
            .dispatch("STREAMING_CHECK_STREAM_STATUS", {
              stream_key: vm.channel.event_live_input.stream_key,
              activeStreamId: vm.stream_data.id
            })
            .then((response) => {
              vm.stream_status = response.data.return;
              if (response.data.return == "offline") {
                vm.hlsStreamingPath = "";
                vm.dashStreamingPath = "";
                vm.webRtcStreamingPath = "";
                vm.is_waiting_streamed_video = true;
              } else if (response.data.return == "live") {
                if (vm.is_waiting_streamed_video) {
                  vm.stream_data.session_id = response.data.stream.session_id;
                  vm.hlsStreamingPath = LIVE_STREAMING_CDN_SERVER_BASE_URL + "/watch.rw/" + response.data.stream.session_id + "/master.m3u8";
                  vm.dashStreamingPath = LIVE_STREAMING_CDN_SERVER_BASE_URL + "/watch.rw/" + response.data.stream.session_id + "/manifest.mpd";
                  // vm.webRtcStreamingPath =  vm.$store.state.WEBRTC_STREAMING_SERVER_BASE_URL + "/watch.rw/" + vm.channel.event_live_input.stream_key + "/abr";
                  vm.is_waiting_streamed_video = false;
                }
              } else {
                vm.hlsStreamingPath = "";
                vm.dashStreamingPath = "";
                vm.webRtcStreamingPath = "";
                vm.is_waiting_streamed_video = true;
              }
            })
            .catch(({ response }) => {
            });
        }
      }, 1000 * 5);
    },
    getEarningAmount() {
      let vm = this;
      if (vm.stream_data) {
        vm.$store
          .dispatch("STREAMING_GET_MY_EVENT_EARNINGS", {
            event_id: vm.stream_data.id,
          })
          .then((response) => {
            vm.current_earnings = response.data.return;
          })
          .catch(({ response }) => { });
      }
    },
    countWhoseWatching() {
      let vm = this;
      if (vm.stream_data) {
        const payload = {
          stream_id: vm.stream_data.id,
          isLive: true
        }
        vm.$store
          .dispatch("STREAMING_GET_EVENT_VIEWS", payload)
          .then((response) => {
            vm.users_current_live = response.data.return.views;
          })
          .catch(({ response }) => { });
      }
    },
    getMyChannelDetails() {
      let vm = this;
      vm.stream_data_loading = true;
      vm.$store
        .dispatch("CHANNEL_GET_MY_DETAILS")
        .then((response) => {
          vm.form.channel_id = response.data.return.id;
          vm.channel = response.data.return;
          vm.getMyActiveStream();
        })
        .catch((error) => {
          console.error(error);
        });
    },
    switchStreamTab(tab) {
      let vm = this;
      vm.stream_tab = tab;
    },
    onStreamDetailsSaved(data) {
      let vm = this;
      vm.show_update_stream_details_modal = false;
      vm.stream_data = data;
      vm.updateFields(vm.stream_data);
    },
    showUpdateDetailsModal() {
      let vm = this;
      vm.show_update_stream_details_modal = true;
    },
    updateFields(item) {
      let vm = this;
      vm.form.id = item.id;
      vm.form.title = item.title;
      vm.form.channel_id = item.channel_id;
      vm.form.category = item.category;
      vm.form.visibility = item.visibility;
      vm.form.allow_payment = item.allow_payment == 1 ? true : false;
      vm.form.keep_video = item.keep_stream == 1 ? true : false;
      vm.form.show_views = item.show_views == 1 ? true : false;
      vm.form.allow_chat = item.allow_chat == 1 ? true : false;
      vm.form.allow_super_chat = item.allow_super_chat == 1 ? true : false;
      vm.form.allow_remote_input = false;
      vm.form.remote_input_headers = false;
      vm.form.player_url = item.player_url;
      vm.form.allowStreamFromOtherSource = item.allowStreamFromOtherSource == 1 ? true : false;
      vm.form.otherSourceUrl = item.otherStreamSourceUrl;
      vm.form.donationId = item.donationId;
      vm.form.stream_key = vm.channel.event_live_input.stream_key;
      vm.form.stream_url = vm.channel.event_live_input.stream_url;
      vm.form.stream_latency = item.stream_latency;

    },
    onSettingsUpdated(form) {
      let vm = this;
      vm.form = form;
      if (vm.form.id && !vm.update_stream_setting_loading) {
        vm.update_stream_setting_loading = true;
        vm.$store
          .dispatch("STREAMING_UPDATE_MY_STREAM", vm.form)
          .then((response) => {
            vm.update_stream_setting_loading = false;
            vm.$buefy.toast.open({
              message: "Settings updated",
              type: "is-success",
            });
          })
          .catch(({ response }) => {
            vm.update_stream_setting_loading = false;
          });
      }
    },
    startNewStream() {
      let vm = this;
      vm.$buefy.dialog.confirm({
        title: "Start a new stream",
        message:
          "Are you sure you want to start a new stream? This will close the current stream.",
        confirmText: "Start",
        type: "is-warning",
        hasIcon: true,
        onConfirm: () => {
          vm.add_stream_loading = true;
          vm.form.title = "Untitled live streaming";
          vm.form.allowStreamFromOtherSource = false;
          vm.form.otherSourceUrl = "";
          vm.$store
            .dispatch("STREAMING_ADD_MY_STREAM", vm.form)
            .then((response) => {
              vm.add_stream_loading = false;
              vm.$notify({
                group: "status",
                type: "success",
                title: "Important message",
                text: response.data.message,
              });
              vm.getMyActiveStream();
            })
            .catch(({ response }) => {
              vm.add_stream_loading = false;
              vm.$notify({
                group: "status",
                type: "warn",
                title: "OOPS!!!",
                text: response.data.message,
              });
            });
        },
      });

    },
    closeStream() {
      let vm = this;
      vm.$buefy.dialog.confirm({
        title: "Close stream",
        message:
          "Are you sure you want to close the stream?",
        confirmText: "Close",
        type: "is-warning",
        hasIcon: true,
        onConfirm: () => {
          vm.initiateCloseStream();
        },
      });
    },
    initiateCloseStream() {
      let vm = this;
      vm.close_stream_loading = true;
      vm.$store
        .dispatch("STREAMING_CLOSE_MY_STREAM", {
          event_id: vm.form.id,
          channel_id: vm.form.channel_id,
          stream_key: vm.form.stream_key,
        })
        .then((response) => {
          vm.close_stream_loading = false;
          vm.$notify({
            group: "status",
            type: "success",
            title: "Important message",
            text: response.data.message,
          });
          vm.getMyActiveStream();
        })
        .catch(({ response }) => {
          vm.close_stream_loading = false;
          vm.$notify({
            group: "status",
            type: "warn",
            title: "OOPS!!!",
            text: response.data.message,
          });
        });
    },
    endStream() {
      let vm = this;
      vm.$buefy.dialog.confirm({
        title: "End stream",
        message:
          "Are you sure you want to end the stream?",
        confirmText: "End",
        type: "is-warning",
        hasIcon: true,
        onConfirm: () => {
          vm.end_stream_loading = true;
          vm.$store
            .dispatch("STREAMING_END_MY_STREAM", {
              event_id: vm.form.id,
              stream_key: vm.form.stream_key,
              sessionId: vm.stream_data.session_id,
            })
            .then((response) => {
              vm.end_stream_loading = false;
              vm.$notify({
                group: "status",
                type: "success",
                title: "Important message",
                text: response.data.message,
              });
              vm.initiateCloseStream();
            })
            .catch(({ response }) => {
              vm.end_stream_loading = false;
              vm.$notify({
                group: "status",
                type: "warn",
                title: "OOPS!!!",
                text: response.data.message,
              });
            });
        },
      });
    },
    getMyActiveStream() {
      let vm = this;
      vm.stream_data_loading = true;
      vm.$store
        .dispatch("STREAMING_GET_MY_ACTIVE_STREAM")
        .then((response) => {
          vm.stream_data_loading = false;
          vm.stream_data = response.data.return;
          vm.updateFields(vm.stream_data);
          vm.getEventChats(vm.form.id);
          vm.$socket.socketServer.emit("JOIN_ROOM", {
            room: "event_room_" + vm.form.id,
          });
          vm.getEarningAmount();
          vm.countWhoseWatching();
          if (
            vm.channel.event_live_input.input_status == "live" &&
            vm.channel.event_live_input.stream_key
          ) {
            vm.hlsStreamingPath = LIVE_STREAMING_CDN_SERVER_BASE_URL + "/watch.rw/" + vm.stream_data.session_id + "/master.m3u8";
            vm.dashStreamingPath = LIVE_STREAMING_CDN_SERVER_BASE_URL + "/watch.rw/" + vm.stream_data.session_id + "/manifest.mpd";
            //vm.webRtcStreamingPath = vm.$store.state.WEBRTC_STREAMING_SERVER_BASE_URL + "/app/" + vm.channel.event_live_input.stream_key + "/abr";
            vm.is_waiting_streamed_video = false;
          } else {
            vm.hlsStreamingPath = "";
            vm.dashStreamingPath = "";
            vm.webRtcStreamingPath = "";
            vm.is_waiting_streamed_video = true;
          }
        })
        .catch(({ response }) => {
          vm.stream_data_loading = false;
        });
    },
    getEventChats(id) {
      let vm = this;
      let chat_list = document.querySelector("#streaming-live-chat-body");
      vm.$store.dispatch("STREAMING_GET_MY_EVENT_CHATS", {
        event_id: id,
        channel_id: vm.form.channel_id,
      }).then((response) => {
        vm.chats = response.data.return;
        setTimeout(() => {
          if (chat_list) {
            chat_list.scrollTo({
              top: chat_list.scrollHeight,
              behavior: "smooth",
            });
          }
        }, 800);
      }).catch((error) => {

      });
    },
    sendChatMessage() {
      let vm = this;
      if (!vm.chat_form.user_name) {
        vm.$buefy.toast.open({
          message: "Name cannot be empty",
          type: "is-danger",
        });
      }
      if (!vm.chat_form.message) {
        vm.$buefy.toast.open({
          message: "Message cannot be empty",
          type: "is-danger",
        });
        return;
      }
      vm.loading_send_message = true;
      vm.$store
        .dispatch("STREAMING_SEND_MY_EVENT_CHAT", {
          event_id: vm.form.id,
          channel_id: vm.form.channel_id,
          message: vm.chat_form.message,
          user_name: vm.chat_form.user_name,
        })
        .then((response) => {
          vm.loading_send_message = false;
          vm.chat_form.message = "";
          vm.chats.push(response.data.return);
          vm.$socket.socketServer.emit("STREAMING_EVENT_SEND_CHAT", {
            event_id: vm.form.id,
            chat: response.data.return,
          });
          let chat_list = document.querySelector("#streaming-live-chat-body");
          setTimeout(() => {
            if (chat_list) {
              chat_list.scrollTo({
                top: chat_list.scrollHeight,
                behavior: "smooth",
              });
            }
          }, 500);
        })
        .catch(({ response }) => {
          vm.loading_send_message = false;
        });

    },
    switchTab(type) {
      let vm = this;
      vm.$emit("tab", type);
    },
  },
};
</script>
<style lang="scss" scoped>
.wrapper {
  padding: 0px;
  display: flex;
  flex-direction: column;
  height: 100%;

  .wrapper-header {
    width: 100%;
    height: 60px;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #ddd;
    overflow-x: auto;

    .tabs-widget {
      display: flex;
      align-items: flex-end;

      .h-spacer {
        margin-right: 20px;
      }

      .tab-item {
        cursor: pointer;
        padding: 14px 4px;
        white-space: nowrap;

        &.active {
          color: var(--wecodefy-secondary-color, #9fc953);
          border-bottom: 3px solid var(--wecodefy-secondary-color, #9fc953);
        }
      }
    }

    .tab-options {
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0px 10px;

      .h-spacer {
        margin-right: 10px;
      }
    }
  }

  .wrapper-body {
    height: calc(100% - 60px);
    display: flex;

    @media (max-width: 780px) {
      flex-direction: column;
      overflow-y: auto;
      background-color: #fff;
    }

    .left-panel {
      height: 100%;
      width: 100%;
      background: #fff;
      transition: all 0.3s ease;
      display: flex;
      flex-direction: column;

      @media (max-width: 650px) {
        height: unset;
      }

      .loading-container {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
      }

      &.chat_enabled {
        width: calc(100% - 400px);
        transition: all 0.3s ease;
        overflow-y: auto;

        @media (max-width: 1267px) {
          width: calc(100% - 300px);
        }

        @media (max-width: 780px) {
          width: 100%;
        }
      }

      .video-preview-widget {
        height: 300px;
        width: 100%;
        display: flex;
        padding: 20px 10px;

        @media (max-width: 650px) {
          flex-direction: column;
          height: unset;
        }

        .video-preview-widget-container {
          width: 55%;
          height: 100%;
          display: flex;

          @media(max-width: 1133px) {
            width: 100%;

            .video-preview-widget-loading-widget {
              background: none !important;
            }
          }

          @media (max-width: 650px) {
            margin-bottom: 15px;
          }

          @media (max-width: 650px) {
            flex-direction: column;
            height: unset;
          }

          .video-preview-widget-loading-widget {
            height: 100%;
            width: 100%;
            background: #000;
            border-radius: 5px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;


            .video-preview-loader {
              position: relative;
            }

            .video-preview-waiting {
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;

              h4 {
                color: #fff;
                margin: 5px 0px;
                font-size: 18px;
              }

              h3 {
                color: rgb(219, 219, 219);
                margin: 5px 0px;
                font-size: 13px;
              }
            }
          }

          .video-player-widget {
            height: 100%;
            width: 100%;
            background: #000;
            border-radius: 5px;
            display: flex;
            overflow: hidden;

            @media (max-width: 1133px) {
              height: 300px;
            }
          }
        }

        .stream-details {
          width: 45%;
          height: 100%;
          display: flex;
          flex-direction: column;
          padding-left: 10px;

          .stream-details-options {
            display: flex;
            column-gap: 5px;
            row-gap: 5px;

            .liveChatBtn {
              display: none;

              @media (max-width: 780px) {
                display: flex;
              }
            }
          }

          @media (max-width: 1133px) {
            width: 100%;
          }
        }
      }

      .stream-status-widget {
        height: 50px;
        width: 100%;
        display: flex;
        align-items: center;
        border-top: 1px solid #ddd;
        border-bottom: 1px solid #ddd;
        padding: 0px 10px;

        .stream-dot {
          height: 15px;
          width: 15px;
          background-color: #ccc;
          border-radius: 50px;
          margin-right: 10px;

          &.active {
            background-color: rgb(3, 206, 64);
          }
        }

        .stream-status {
          font-size: 13px;
        }
      }

      .stream-details-content {
        width: 100%;
      }

      .stream-tab-header {
        width: 100%;
        height: 50px;
        background: #fff;
        display: flex;
        align-items: center;
        justify-content: space-between;
        border-bottom: 1px solid #ddd;
        padding: 0px 10px;

        .tabs-widget {
          display: flex;
          align-items: flex-end;
          overflow-x: auto;

          .h-spacer {
            margin-right: 20px;
          }

          .tab-item {
            cursor: pointer;
            padding: 14px 4px;
            white-space: nowrap;

            &.active {
              color: var(--wecodefy-secondary-color, #9fc953);
              border-bottom: 3px solid var(--wecodefy-secondary-color, #9fc953);
            }
          }
        }

        .tab-options {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0px 10px;

          .h-spacer {
            margin-right: 10px;
          }
        }
      }

    }

    .rigth-panel {
      width: 0px;
      height: 100%;
      background: #fff;
      border-left: 1px solid #ddd;
      display: flex;
      flex-direction: column;
      transition: width 0.5s ease;
      visibility: hidden;

      &.show {
        width: 400px;
        transition: width 0.5s ease;
        visibility: visible;
        transition: .5s;

        @media (max-width: 1267px) {
          width: 300px;
        }

        @media (max-width: 780px) {
          position: absolute;
          z-index: 10;
          top: 60px;
          right: -300px;

          &.show_mobile {
            right: 0;
          }
        }
      }

      .right-panel-header {
        height: 60px;
        display: flex;
        align-items: center;
        padding: 0px 10px;
        border-bottom: 1px solid #ddd;

        h3 {
          display: flex;
          justify-content: space-between;
          align-items: center;
          width: 100%;

          span {
            color: red;
            font-weight: 700;
            cursor: pointer;
            display: none;

            @media (max-width: 780px) {
              display: flex;
            }
          }
        }
      }

      .right-panel-body {
        height: calc(100% - 260px);
        overflow-y: auto;

        .chat-list {
          padding-right: 10px;

          .chat-item {
            display: flex;
            padding: 2px 10px;
            margin-bottom: 10px;

            .chat-user-profile {
              display: flex;
              padding-top: 10px;
              width: 30px;
              height: 30px;

              .chat-user-image {
                width: 100%;
                height: 100%;
                border-radius: 50%;
                overflow: hidden;
                margin-right: 10px;
              }
            }

            .chat-message {
              width: calc(100% - 30px);
              color: #000;
              font-size: 13px;
              font-weight: 400;
              margin-top: 5px;

              .chat-user-name {
                color: #000;
                font-size: 14px;
                font-weight: 800;
              }
            }
          }
        }
      }

      .right-panel-footer {
        height: 200px;
        display: flex;
        flex-direction: column;
        border: 1px solid #ddd;
        padding: 10px 0px;

        .custom-name {
          width: 100%;
          padding: 0px 10px;
          margin-bottom: 10px;
          display: flex;

          .user-name {
            width: calc(100% - 70px);
            margin-right: 10px;
          }

          .chat-send {
            width: 70px;
            display: flex;
            align-items: center;
            justify-content: center;
          }
        }

        .chat-input-widget {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 0px 10px;

          .chat-input {
            width: 100%;
          }

        }

      }
    }
  }
}
</style>

<style lang="scss">
.money-reveal-input {
  border-bottom: 1px solid #ddd !important;

  input {
    border: none !important;
    padding-left: 0px;
  }
}
</style>